import type { GameTheme } from "@skillscratch/shared-types";
import background from "./background.webp";
import name from "./name.webp";
import overlay from "./overlay.webp";
import card from "./card.png";

export const crazy99s = {
  id: "crazy-99s",
  name: "Crazy 99s",
  
  colorScheme: {
    tileColors: [
      { background: "#9932CC", text: "#fff" },  // very bright purple (dark orchid)
      { background: "#8A2BE2", text: "#fff" },  // bright purple (blue violet)
      { background: "#663399", text: "#fff" },  // medium-dark purple (rebecca purple)
      { background: "#4B0082", text: "#fff" },  // dark purple (indigo)
    ],
    overlayPattern: overlay,
    overlayColor: "#3B0066",  // darker purple for overlay
    scratchColor: "#5D1694",  // darker purple for scratch
    
    controlColor: "#6A287E",  // darker purple for control
    onControlColor: "#fff",
  },
  
  nameImage: name,
  background: background,
  card: card,
} satisfies GameTheme;